import {useContext} from 'react';
import {CustomerContext} from '../context/CustomerContext';

export function useCustomer() {
    const {customerData, acceptAgeGate, updateCustomer} = useContext(CustomerContext);
    return {customerData, acceptAgeGate, updateCustomer};
}
